import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.join.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-55c066d4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "col-xl-4 order-xl-2 mb-5 mb-xl-0 mt-6"
};
var _hoisted_2 = {
  "class": "card card-profile shadow"
};
var _hoisted_3 = {
  "class": "row justify-content-center"
};
var _hoisted_4 = {
  "class": "col-lg-3 order-lg-2"
};
var _hoisted_5 = {
  "class": "card-profile-image"
};
var _hoisted_6 = {
  href: "#"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  "class": "card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
};
var _hoisted_9 = {
  "class": "text-right"
};
var _hoisted_10 = {
  "class": "card-body pt-0 pt-md-4 mt-5"
};
var _hoisted_11 = {
  "class": "row"
};
var _hoisted_12 = {
  "class": "col"
};
var _hoisted_13 = {
  "class": "card-profile-stats d-flex justify-content-center mt-md-5"
};
var _hoisted_14 = {
  "class": "heading"
};
var _hoisted_15 = {
  "class": "text-left"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("hr", {
    "class": "my-4"
  }, null, -1);
});

var _hoisted_17 = ["innerHTML"];
var _hoisted_18 = {
  "class": "text-danger"
};
var _hoisted_19 = {
  "class": "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_button = _resolveComponent("base-button");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_form = _resolveComponent("el-form");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("a", _hoisted_6, [_createElementVNode("img", {
    src: $props.game.poster,
    "class": "rounded-circle"
  }, null, 8, _hoisted_7)])])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [$props.game.joinType == 0 ? (_openBlock(), _createBlock(_component_base_button, {
    key: 0,
    size: "sm",
    type: "default",
    "class": "float-right",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.goTo($props.game.link);
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.enter")), 1)];
    }),
    _: 1
  })) : _createCommentVNode("", true), $props.game.joinType == 1 && !$data.isHavePermission && $data.isloadEnd && _ctx.loginData ? (_openBlock(), _createBlock(_component_base_button, {
    key: 1,
    size: "sm",
    type: "default",
    "class": "float-right",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.authorize();
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.authorize")), 1)];
    }),
    _: 1
  })) : _createCommentVNode("", true), $props.game.joinType == 1 && $data.isHavePermission && $data.isloadEnd && _ctx.loginData && !$options.isJoined($props.game.joinItem) || $props.game.joinType == 1 && !_ctx.loginData ? (_openBlock(), _createBlock(_component_el_button, {
    key: 2,
    loading: $data.isLoadJoinAutoClaimReward,
    type: "primary",
    "class": "float-right",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.join($props.game.joinItem);
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.join")), 1)];
    }),
    _: 1
  }, 8, ["loading"])) : _createCommentVNode("", true), $props.game.joinType == 1 && $data.isHavePermission && $data.isloadEnd && _ctx.loginData && $options.isJoined($props.game.joinItem) ? (_openBlock(), _createBlock(_component_el_button, {
    key: 3,
    loading: $data.isLoadJoinAutoClaimReward,
    type: "success",
    "class": "float-right"
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.joined")), 1)];
    }),
    _: 1
  }, 8, ["loading"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("label." + $props.game.title)), 1)])])])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("p", {
    innerHTML: _ctx.$t("label." + $props.game.intro)
  }, null, 8, _hoisted_17)])])])]), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.dialogVisible = $event;
    }),
    title: _ctx.$t('label.authorize'),
    width: "60%"
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_19, [_createVNode(_component_el_button, {
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return $data.dialogVisible = false;
        })
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return $options.confirmAuthorize();
        }),
        loading: $data.isLoading
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
        }),
        _: 1
      }, 8, ["loading"])])];
    }),
    "default": _withCtx(function () {
      return [_createElementVNode("span", null, _toDisplayString(_ctx.$t("label.sapAuthorizeTips", {
        username: $props.game.username
      })), 1), !$data.isUseKeychain ? (_openBlock(), _createBlock(_component_el_form, {
        key: 0,
        "label-width": "90px"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            label: _ctx.$t('label.activeKey')
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_input, {
                "show-password": "",
                modelValue: $data.acitveKey,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return $data.acitveKey = $event;
                }),
                placeholder: _ctx.$t('label.InputActivePassWord'),
                "class": "input-with-select"
              }, null, 8, ["modelValue", "placeholder"])];
            }),
            _: 1
          }, 8, ["label"])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", null, [_createElementVNode("small", _hoisted_18, _toDisplayString(_ctx.$t($data.errorMessage)), 1)], 512), [[_vShow, $data.isError]])];
    }),
    _: 1
  }, 8, ["modelValue", "title"])], 64);
}